import React from "react";

interface Props {
  title?: string;
  parrafo?: string;
}

const FormTitle = ({ title, parrafo }: Props) => {
  return (
    <>
      <div className="title-form">{title}</div>
      <div className="parrafo-form">{parrafo}</div>
    </>
  );
};

export default FormTitle;
